<template>
    <svg class="my-svg-component" version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000.000000 2000.000000" preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0.000000,2000.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path d="M13865 16715 c-643 -267 -1176 -485 -1184 -485 -7 0 -45 -31 -85 -69
-39 -37 -426 -396 -861 -796 -434 -401 -984 -907 -1221 -1126 l-431 -397 -354
-229 -355 -228 -1014 -78 -1015 -78 -1067 1 -1066 0 -299 -237 c-980 -779
-1279 -1017 -1284 -1025 -3 -4 -16 -61 -29 -126 -13 -64 -27 -122 -32 -128 -5
-7 -30 -15 -55 -19 -134 -20 -765 -144 -776 -153 -6 -5 -275 -208 -597 -451
-322 -242 -594 -449 -605 -460 -11 -10 -147 -114 -302 -230 -250 -187 -283
-214 -283 -239 0 -15 36 -468 80 -1007 44 -539 104 -1295 135 -1680 30 -385
57 -727 61 -761 l6 -61 265 -299 c237 -266 789 -864 799 -864 6 0 -8 34 -297
722 l-267 637 -27 183 c-15 101 -96 646 -180 1212 l-154 1028 61 347 c33 190
62 348 64 350 4 4 1792 380 1809 380 6 1 176 -289 380 -642 l370 -643 803
-524 c442 -289 808 -528 814 -531 5 -3 47 -372 94 -820 46 -448 89 -827 96
-842 9 -24 48 -47 237 -142 211 -106 281 -149 1048 -652 l823 -538 180 -235
c201 -264 181 -248 326 -249 l70 -1 53 -66 53 -66 -65 -67 -65 -66 27 -267
c15 -147 30 -270 33 -273 3 -4 182 -52 398 -108 l391 -101 45 17 44 16 0 -212
1 -212 127 -157 127 -157 53 0 c44 -1 140 29 545 170 271 94 495 174 499 178
4 3 -209 184 -473 401 l-481 395 -553 736 -553 735 -202 515 c-112 283 -236
597 -277 699 -73 184 -75 192 -314 1183 -132 549 -239 1002 -237 1006 3 7 187
-18 1453 -195 341 -48 625 -86 630 -86 12 0 1312 225 1429 247 43 8 88 15 100
15 12 0 107 -68 228 -162 l208 -163 233 -290 c128 -159 435 -542 682 -850 247
-308 470 -585 495 -615 l46 -56 18 -369 c17 -366 17 -369 -2 -384 -11 -9 -252
-220 -535 -468 -284 -249 -519 -453 -524 -453 -4 0 -30 50 -57 110 -37 85 -53
109 -65 106 -9 -3 -134 -39 -278 -81 -144 -41 -271 -79 -282 -83 -14 -5 -96
-137 -236 -376 l-215 -369 167 6 c93 4 269 10 393 13 l225 7 256 87 256 88
279 -13 c154 -7 279 -12 280 -11 0 0 162 260 358 576 l358 576 180 98 c99 54
186 109 194 122 9 13 37 167 71 383 l55 361 -471 1063 c-437 985 -471 1067
-471 1118 l0 55 163 160 c89 88 199 195 244 238 l82 78 988 -452 c543 -249
997 -462 1007 -473 17 -17 322 -477 454 -683 l50 -79 37 -699 c29 -544 35
-703 26 -720 -7 -11 -38 -50 -69 -84 l-57 -64 -137 13 c-121 11 -139 11 -160
-3 -17 -11 -48 -74 -106 -209 -45 -107 -82 -201 -82 -209 0 -26 112 -545 119
-552 14 -15 445 -168 453 -160 4 4 69 111 144 237 l136 230 185 510 c102 281
191 529 199 553 12 40 6 77 -121 741 l-134 699 -120 404 c-67 222 -121 417
-121 432 0 22 -4 27 -16 22 -14 -6 -272 167 -789 528 l-129 91 -323 430 c-177
237 -334 447 -349 467 l-26 37 113 163 c62 90 126 183 143 207 l31 43 21 407
20 406 -135 272 -135 271 158 339 157 338 194 154 c106 84 195 154 198 155 2
0 50 -28 105 -63 l101 -64 -44 -88 -44 -88 54 -428 c30 -235 55 -432 55 -436
0 -5 70 -80 155 -167 85 -86 155 -163 155 -170 0 -6 70 -228 155 -492 85 -264
155 -489 155 -499 0 -9 -38 -160 -85 -334 -47 -174 -85 -321 -85 -328 0 -7 51
-40 113 -74 75 -42 150 -95 225 -159 101 -86 113 -101 124 -142 l12 -47 8 41
9 42 232 80 c128 44 286 99 352 122 66 23 125 47 132 53 6 7 107 215 224 462
l212 450 14 235 13 235 103 485 104 484 79 71 c44 38 100 88 126 110 l46 40
-22 204 -22 203 35 -5 c20 -3 182 -40 361 -82 179 -42 341 -80 362 -84 l36 -8
-15 50 c-8 28 -46 152 -84 275 -38 123 -69 228 -69 233 0 5 7 9 15 9 13 0 72
15 295 75 30 8 123 33 205 55 83 23 157 43 166 46 11 3 14 13 11 33 l-4 28
-63 -13 c-62 -13 -674 -69 -679 -63 -6 7 -196 634 -196 644 1 6 90 91 199 190
l197 180 -321 5 -322 5 -584 576 c-328 324 -632 616 -694 665 -60 49 -521 423
-1024 831 l-913 743 -67 0 c-64 -1 -99 -14 -1236 -485z m1755 -625 c0 -11
-1761 -48 -1790 -38 -7 2 86 87 206 188 121 102 410 346 643 544 l425 359 258
-523 c142 -288 258 -526 258 -530z m-730 957 c-14 -12 -286 -242 -604 -512
-425 -359 -585 -489 -600 -487 -12 2 -208 37 -437 78 -228 41 -419 74 -424 74
-4 0 -5 3 -2 7 9 8 2068 861 2082 862 6 0 -1 -10 -15 -22z m865 -413 c149
-120 479 -388 733 -594 255 -206 459 -376 454 -378 -7 -2 -1126 369 -1205 400
-25 10 -59 71 -268 496 -131 267 -239 489 -239 494 0 5 57 -38 128 -95 70 -57
249 -202 397 -323z m-2607 -559 c235 -42 435 -79 446 -83 14 -6 -185 -128
-829 -510 -466 -277 -849 -501 -851 -500 -1 2 67 107 153 233 85 127 248 367
361 535 241 358 271 400 283 400 5 0 202 -34 437 -75z m3451 -1063 c508 -548
926 -1003 929 -1010 3 -11 -219 -483 -238 -505 -4 -5 -278 20 -608 54 l-600
63 -157 361 c-87 198 -241 551 -342 785 -102 234 -190 430 -197 436 -9 9
-1330 196 -1379 194 -10 0 -819 -320 -1799 -710 -979 -391 -1782 -709 -1784
-707 -9 8 714 463 1092 688 458 271 770 457 1629 968 l590 351 195 1 c107 1
454 7 770 13 316 7 665 13 775 14 l200 1 924 -997z m-128 733 c354 -119 647
-219 651 -223 9 -10 380 -1362 376 -1372 -2 -4 -176 179 -388 407 -212 229
-510 551 -664 717 -153 166 -359 388 -458 494 -99 105 -176 192 -171 192 5 0
299 -97 654 -215z m-4007 183 c-9 -16 -578 -864 -647 -964 l-48 -71 -176 33
c-97 18 -177 35 -179 37 -3 3 1047 976 1054 977 2 0 0 -6 -4 -12z m5301 -1028
c231 -229 492 -486 580 -573 l161 -157 123 -405 c68 -223 122 -408 119 -410
-2 -2 -168 -18 -368 -35 l-365 -31 -37 43 c-21 24 -38 47 -38 52 0 5 65 137
145 292 81 156 142 284 138 285 -4 0 -145 17 -313 37 l-305 37 -182 665 c-100
366 -185 679 -188 695 -7 29 -5 28 51 -25 33 -30 248 -242 479 -470z m-3295
360 c809 -112 875 -122 876 -123 1 -3 84 -193 199 -459 l103 -236 -57 -6
c-166 -18 -1950 -166 -1973 -164 -19 2 -135 95 -379 302 -297 252 -349 301
-333 308 121 53 1094 437 1109 437 11 1 215 -26 455 -59z m-2957 -387 c86 -15
156 -31 155 -35 -2 -4 -142 -90 -313 -191 -170 -101 -433 -264 -584 -361 -151
-98 -284 -182 -295 -188 -19 -9 -19 -9 -6 5 52 55 867 796 875 797 6 0 81 -12
168 -27z m1667 -342 c179 -151 331 -279 338 -286 11 -10 -89 -105 -548 -516
-310 -277 -566 -505 -570 -507 -5 -2 -1 25 7 60 35 144 191 738 284 1078 142
518 128 473 147 458 10 -7 163 -136 342 -287z m-434 273 c-9 -23 -175 -624
-245 -884 -69 -259 -164 -638 -181 -723 -6 -32 -17 -60 -24 -63 -7 -3 -174 47
-372 109 -197 63 -671 212 -1051 333 -381 120 -690 221 -685 225 4 3 189 79
412 167 741 294 2044 812 2090 831 57 24 64 25 56 5z m2858 -501 c-14 -38
-145 -385 -290 -773 -146 -387 -268 -708 -272 -711 -6 -6 -795 -131 -797 -126
-2 3 -594 1481 -600 1498 -5 13 44 19 382 48 213 18 636 54 938 81 303 26 576
48 607 49 l57 1 -25 -67z m3295 30 c0 -12 -278 -238 -291 -238 -6 0 -17 23
-25 50 -11 39 -30 65 -86 123 l-71 72 237 0 c130 0 237 -3 236 -7z m-3033
-388 l158 -360 -145 -283 c-79 -156 -147 -286 -152 -289 -11 -7 -207 118 -207
133 0 7 38 269 85 583 47 313 85 576 85 583 0 30 28 -28 176 -367z m-1997
-506 c161 -402 296 -740 298 -750 6 -20 53 4 -876 -450 -156 -77 -289 -139
-295 -138 -11 0 -649 957 -648 973 0 4 161 152 359 329 197 176 470 421 608
544 137 122 252 223 255 223 3 0 138 -329 299 -731z m1643 131 l-67 -444 -140
-113 c-77 -62 -143 -113 -147 -113 -4 0 3 28 16 63 13 34 108 289 212 565 103
277 189 500 191 495 1 -4 -28 -208 -65 -453z m2346 366 c106 -13 195 -26 197
-28 4 -3 -638 -375 -667 -386 -18 -7 197 416 217 426 28 15 37 14 253 -12z
m116 -328 c-95 -190 -114 -235 -105 -250 6 -9 75 -100 155 -200 l143 -183 23
-274 c18 -229 20 -275 9 -285 -8 -7 -48 -43 -90 -80 l-77 -67 -205 353 c-454
780 -466 803 -454 810 134 79 704 406 710 407 4 1 -45 -103 -109 -231z m-7437
-2 c945 -297 1708 -538 1711 -541 2 -2 -238 -605 -245 -614 -5 -7 -67 15 -768
269 -352 127 -746 270 -875 316 -707 255 -876 317 -883 324 -4 4 65 54 155
111 90 57 224 143 298 191 74 48 138 88 142 88 4 0 213 -65 465 -144z m6158
-127 c325 -34 591 -62 592 -63 2 -1 153 -263 337 -581 226 -391 331 -582 323
-586 -17 -9 -502 -141 -677 -184 -79 -19 -153 -32 -165 -29 -17 5 -1083 553
-1337 687 -43 22 -78 45 -78 50 0 10 368 735 383 755 5 6 15 12 21 12 6 0 277
-27 601 -61z m-6198 -566 c607 -219 1099 -399 1093 -401 -5 -2 -242 31 -527
73 -831 122 -1109 163 -1423 209 -162 24 -521 77 -797 117 -277 41 -503 76
-503 80 0 3 111 38 248 79 136 40 371 110 522 156 151 45 277 83 280 83 3 1
501 -178 1107 -396z m8562 393 c-2 -2 -51 -16 -109 -31 -58 -14 -161 -42 -230
-60 -126 -35 -191 -52 -395 -105 -61 -16 -118 -32 -126 -35 -11 -4 -34 18 -78
75 -34 44 -59 80 -55 80 14 0 719 60 804 69 95 9 196 13 189 7z m-10049 -41
c-41 -13 -302 -91 -580 -174 -757 -225 -2181 -649 -2555 -761 -805 -240 -1016
-302 -1021 -298 -2 3 85 258 193 566 l198 562 1065 0 1065 1 800 63 c440 35
825 64 855 64 l55 0 -75 -23z m9867 -313 c36 -117 63 -216 60 -218 -11 -11
-679 150 -687 166 -4 8 -10 39 -12 68 l-5 52 56 16 c31 8 79 21 106 28 28 8
77 21 110 30 33 9 107 29 165 45 58 17 113 29 124 28 15 -2 30 -41 83 -215z
m-14028 -702 c-159 -454 -292 -826 -294 -828 -3 -4 -803 506 -827 527 -4 3 41
44 100 91 193 153 1196 952 1251 997 30 24 55 42 57 40 2 -2 -127 -374 -287
-827z m7761 303 c156 -233 282 -424 279 -427 -3 -3 -806 282 -817 290 -2 1 49
133 114 293 92 226 121 288 130 279 6 -7 139 -203 294 -435z m-4303 367 c207
-31 734 -108 2248 -330 754 -110 1382 -202 1396 -206 l27 -5 -178 -442 c-98
-243 -273 -676 -388 -962 -116 -286 -307 -758 -425 -1050 l-213 -530 -480 0
c-263 0 -898 3 -1411 8 l-932 7 -768 403 -768 403 -835 539 c-459 296 -863
556 -897 578 -35 21 -63 45 -63 51 0 17 188 548 197 557 5 4 193 62 418 129
226 67 583 174 795 237 726 216 946 282 1505 448 308 91 571 170 585 175 36
12 35 12 187 -10z m6695 -199 c-26 -66 -268 -570 -274 -568 -15 5 -430 469
-424 474 3 3 151 28 328 54 178 27 330 51 338 53 33 8 39 6 32 -13z m1280
-337 c326 -169 622 -322 657 -342 l64 -35 -472 -189 -473 -189 -136 142 c-75
78 -140 149 -144 158 -6 12 -98 726 -98 755 0 3 2 6 5 6 3 0 271 -138 597
-306z m-1787 -74 l217 -235 134 -275 135 -274 -19 -388 -18 -387 -41 -58 c-22
-32 -85 -124 -141 -204 l-101 -147 -131 -88 c-141 -96 -511 -349 -815 -556
-324 -221 -475 -321 -479 -317 -2 2 -49 585 -105 1294 -55 710 -103 1304 -105
1321 l-4 32 596 290 597 291 32 -32 c17 -18 129 -138 248 -267z m-2006 -117
c238 -87 435 -163 438 -170 2 -6 -104 -316 -237 -690 -133 -373 -296 -832
-363 -1020 -67 -189 -124 -343 -127 -343 -3 0 -24 55 -47 123 -22 67 -138 404
-257 749 l-215 626 59 147 c33 81 112 276 176 433 125 309 122 302 132 302 4
0 202 -71 441 -157z m5471 -24 c0 -5 -45 -225 -101 -487 l-100 -477 -11 -220
-11 -220 -208 -445 -207 -444 -322 -114 c-177 -63 -323 -112 -326 -109 -4 3
454 2307 460 2314 0 1 54 13 118 28 65 14 247 61 405 104 329 90 303 84 303
70z m-1118 -1294 c-119 -592 -218 -1072 -222 -1068 -5 6 -479 1735 -484 1767
-1 8 882 372 910 375 7 1 -75 -429 -204 -1074z m-12685 713 c258 -166 790
-509 1183 -763 393 -254 777 -501 853 -549 75 -49 137 -91 137 -95 0 -4 -359
-178 -797 -386 -439 -208 -938 -445 -1110 -527 -171 -81 -315 -148 -320 -148
-4 0 -173 288 -374 639 l-366 638 154 724 c177 838 162 769 168 769 3 0 215
-136 472 -302z m8867 -473 c31 -396 74 -945 96 -1220 22 -275 39 -505 38 -512
-2 -7 -197 94 -456 235 -387 211 -452 250 -449 267 2 11 126 362 275 780 148
418 305 860 349 982 50 142 80 216 85 205 3 -9 32 -341 62 -737z m-9528 233
l-61 -283 -50 -13 c-112 -28 -1647 -363 -1651 -360 -4 5 1030 786 1050 794 23
9 719 142 747 143 l26 1 -61 -282z m8414 -750 l252 -736 -402 -477 c-222 -261
-407 -474 -412 -473 -14 5 -508 449 -508 456 0 4 36 98 81 207 44 110 222 553
396 985 173 432 318 789 320 794 3 5 9 2 13 -5 4 -8 121 -346 260 -751z
m-8495 360 c-3 -13 -30 -138 -61 -278 -30 -139 -56 -255 -58 -257 -2 -2 -250
-55 -552 -119 -302 -63 -675 -141 -829 -174 -154 -32 -281 -57 -282 -56 -4 3
1044 745 1062 752 25 10 680 152 703 153 18 1 21 -3 17 -21z m-916 -182 c-18
-17 -973 -686 -979 -686 -5 0 -6 8 -4 18 2 9 22 120 44 246 22 126 41 230 43
232 1 1 137 32 302 68 165 37 365 81 445 99 131 30 162 35 149 23z m-1018
-482 c-22 -126 -101 -582 -176 -1014 -140 -812 -145 -842 -151 -825 -1 6 -33
389 -70 853 -65 823 -66 843 -48 857 10 8 123 92 249 188 127 96 231 173 233
172 2 -1 -15 -105 -37 -231z m14994 -219 c52 -192 97 -356 100 -362 7 -21 0
-16 -80 52 -42 35 -118 87 -170 115 -54 29 -92 56 -90 63 2 7 32 116 65 242
66 250 71 265 76 250 2 -5 46 -167 99 -360z m-1481 -241 c176 -233 317 -426
315 -427 -5 -4 -1497 258 -1503 264 -5 5 845 587 859 588 6 0 154 -191 329
-425z m-8483 12 c60 -148 107 -272 104 -274 -3 -3 -170 -33 -372 -68 -203 -34
-676 -115 -1053 -179 -377 -64 -696 -119 -710 -122 -62 -14 -90 -28 1025 502
275 131 583 278 685 326 102 49 191 87 198 86 8 -1 63 -123 123 -271z m683
-116 c383 -200 696 -368 696 -372 0 -8 -219 -409 -230 -421 -4 -5 -223 135
-486 311 l-479 320 -90 223 c-49 123 -98 243 -108 267 -9 24 -13 42 -9 40 5
-1 323 -167 706 -368z m5464 -161 c235 -128 445 -242 467 -255 l41 -23 -28
-262 c-16 -145 -29 -263 -31 -264 -5 -4 -1230 -195 -1232 -193 -4 5 347 1228
352 1228 3 0 197 -104 431 -231z m-696 -443 c-87 -306 -162 -558 -166 -559
-10 -3 -386 286 -383 295 5 15 702 834 705 828 1 -4 -69 -258 -156 -564z
m2489 360 c387 -68 750 -132 806 -142 56 -9 106 -20 111 -23 5 -3 65 -186 132
-406 68 -220 125 -406 128 -413 5 -13 -8 -8 -393 169 -132 61 -532 244 -890
408 l-650 298 1 39 c0 21 4 74 8 117 6 63 11 77 25 77 9 0 334 -56 722 -124z
m-815 57 c-2 -10 -8 -55 -11 -100 l-7 -83 -205 -200 c-113 -111 -207 -199
-209 -197 -5 5 28 314 35 325 8 12 384 271 394 272 5 0 6 -8 3 -17z m-7063
-95 c-14 -24 -215 -342 -446 -708 -231 -366 -421 -667 -423 -669 -2 -2 -350
223 -773 500 -424 276 -769 504 -767 506 5 5 2383 411 2414 412 l22 1 -27 -42z
m613 -287 c418 -280 450 -304 461 -339 21 -67 404 -1674 401 -1683 -2 -5 -96
107 -209 249 -227 283 -850 1067 -1000 1258 l-95 121 -12 304 c-7 167 -15 326
-18 353 -5 40 -4 48 8 43 8 -3 217 -141 464 -306z m-502 -521 c21 -421 46
-929 56 -1130 10 -201 17 -367 14 -369 -2 -2 -14 5 -27 16 -12 11 -233 211
-492 443 -258 232 -469 427 -467 432 7 26 868 1386 873 1380 3 -4 23 -351 43
-772z m3873 681 l132 -6 -441 -340 c-243 -187 -447 -341 -454 -343 -11 -3
-1650 692 -1664 705 -7 6 2266 -8 2427 -16z m-1805 -328 c423 -180 766 -328
764 -330 -2 -2 -104 10 -227 27 -283 39 -602 83 -1136 156 -233 32 -423 62
-423 66 0 5 51 101 113 213 83 151 116 203 127 199 8 -2 360 -152 782 -331z
m2312 78 c113 -102 206 -188 206 -191 0 -3 -150 -32 -332 -63 -183 -32 -483
-84 -665 -116 -183 -31 -333 -55 -333 -52 1 3 193 153 427 333 l427 326 31
-26 c18 -15 125 -110 239 -211z m4582 73 c467 -322 604 -417 602 -419 -14 -10
-539 -247 -542 -244 -2 2 -56 175 -121 384 -64 209 -119 383 -122 388 -13 22
31 -4 183 -109z m-14166 -1058 c77 -517 139 -943 138 -948 -2 -5 -17 23 -34
64 -17 40 -115 272 -218 515 l-186 442 70 413 c75 443 79 462 85 456 2 -2 67
-426 145 -942z m11630 575 c0 -16 25 -438 55 -937 31 -499 54 -911 53 -915 -2
-4 -308 371 -681 834 -406 505 -672 844 -665 846 12 4 1199 198 1226 200 7 1
12 -11 12 -28z m3135 -301 c-18 -162 -41 -366 -51 -452 -10 -87 -20 -158 -23
-158 -8 1 -435 660 -430 663 14 10 534 246 536 244 1 -2 -13 -135 -32 -297z
m-9205 -80 c146 -183 438 -549 649 -814 l384 -481 -22 -100 c-37 -162 -286
-940 -311 -968 -3 -4 -71 83 -149 193 l-143 200 -333 833 -333 832 -11 230
c-6 127 -14 277 -17 335 -4 87 -3 102 8 89 7 -8 132 -165 278 -349z m9399 -85
c86 -293 97 -341 201 -885 60 -316 108 -576 106 -578 -3 -2 -152 261 -430 759
l-87 157 50 435 c28 240 51 439 51 444 1 24 26 -52 109 -332z m-2810 -654
l422 -953 -48 -314 c-26 -173 -50 -314 -53 -314 -14 0 -643 734 -651 759 -7
22 -110 1712 -109 1781 0 19 3 21 9 10 5 -8 199 -444 430 -969z m-7384 -46
c116 -103 274 -246 353 -318 l142 -129 -22 -17 c-373 -290 -784 -604 -794
-608 -8 -3 -14 -1 -14 4 0 5 -34 337 -75 738 -41 402 -75 738 -75 748 0 13 43
-20 138 -105 75 -68 232 -209 347 -313z m-5007 350 c17 -39 67 -158 112 -265
113 -269 178 -422 480 -1130 145 -338 269 -630 277 -647 7 -18 11 -33 9 -33
-2 0 -178 197 -392 438 -213 240 -396 447 -407 459 -17 19 -24 83 -68 620 -51
628 -52 639 -44 632 2 -3 17 -36 33 -74z m5857 -844 l287 -723 128 -177 c71
-97 127 -177 126 -178 -1 -2 -80 41 -175 94 l-173 97 -107 220 c-59 122 -163
335 -231 474 l-123 252 -13 273 c-7 149 -15 302 -16 339 -2 37 -1 64 3 60 4
-4 136 -333 294 -731z m9424 -4 c144 -258 259 -472 256 -477 -7 -11 -465 -253
-469 -249 -2 2 -16 234 -30 514 -14 281 -29 553 -32 605 -4 62 -3 91 4 85 5
-5 127 -221 271 -478z m-9527 -429 c117 -240 201 -424 194 -426 -6 -1 -276 47
-601 108 -324 60 -593 110 -598 110 -5 0 -7 4 -5 10 3 9 788 619 798 620 3 0
98 -190 212 -422z m1138 268 c0 -19 548 -1446 562 -1463 17 -21 -9 -35 -36
-21 -83 43 -843 473 -853 482 -9 8 8 67 73 251 90 253 203 610 225 708 6 31
16 57 21 57 4 0 8 -6 8 -14z m5474 -591 c201 -233 280 -331 268 -333 -19 -3
-532 44 -537 50 -1 1 -8 127 -14 278 -7 151 -14 290 -17 309 -3 20 -1 32 5 30
5 -2 138 -152 295 -334z m3007 -245 c-82 -228 -152 -408 -155 -400 -19 51
-143 586 -137 592 16 17 436 236 439 230 1 -4 -65 -194 -147 -422z m-9907 161
c297 -56 535 -106 542 -113 19 -20 612 -873 609 -876 -1 -1 -317 203 -701 454
-862 564 -783 513 -906 579 -57 30 -96 55 -88 55 8 0 253 -45 544 -99z m9621
-309 c35 -141 62 -258 60 -260 -3 -4 -449 399 -454 411 -2 5 13 7 35 4 22 -3
68 -8 104 -11 l65 -5 59 71 c33 39 62 66 64 59 2 -6 32 -128 67 -269z m-8751
21 c94 -53 357 -201 584 -329 227 -128 415 -234 418 -237 6 -5 -541 -227 -558
-227 -10 1 -357 491 -617 870 -7 11 -10 20 -6 20 4 0 84 -44 179 -97z m8540
-133 c126 -113 247 -221 269 -240 l38 -35 -131 -225 c-73 -124 -133 -226 -134
-227 -2 -3 -346 124 -352 129 -4 5 31 656 42 766 5 57 7 62 22 50 9 -7 120
-105 246 -218z m-2494 125 c107 -9 204 -20 214 -24 15 -5 -12 -24 -121 -82
l-141 -74 -298 -482 c-165 -265 -302 -482 -305 -483 -4 0 4 35 18 78 13 42 94
302 180 577 85 275 157 504 160 509 3 4 26 6 52 3 25 -4 134 -13 241 -22z
m2138 -248 c-7 -119 -15 -217 -18 -217 -3 0 -18 56 -33 124 l-27 123 41 97
c23 53 43 95 45 93 2 -1 -2 -100 -8 -220z m-2723 -418 c-102 -331 -187 -604
-188 -605 -5 -5 -616 341 -614 348 3 11 980 868 984 864 2 -2 -80 -275 -182
-607z m-4123 -121 c101 -133 189 -251 197 -263 41 -60 -36 33 -207 250 -164
207 -198 255 -177 255 2 0 86 -109 187 -242z m-346 70 c-19 -46 -73 -183 -121
-306 -48 -123 -89 -221 -91 -219 -15 14 -294 383 -294 388 0 7 509 218 527
219 7 0 -1 -32 -21 -82z m322 -176 c189 -239 201 -257 180 -264 -31 -9 -618
-81 -623 -76 -5 5 227 598 235 597 3 0 96 -116 208 -257z m3198 62 l44 -97
-151 -256 c-83 -141 -156 -261 -162 -267 -8 -8 -117 -16 -326 -23 -173 -6
-315 -10 -316 -9 -2 2 75 136 171 298 95 162 175 298 176 302 3 8 511 157 517
152 2 -2 23 -47 47 -100z m594 -426 l85 -49 -205 7 c-113 4 -207 8 -209 10 -2
1 -99 -30 -217 -71 -118 -41 -214 -72 -214 -69 0 3 59 106 130 229 l131 223
207 -116 c114 -64 245 -138 292 -164z m-3428 -103 c64 -82 115 -151 113 -153
-6 -7 -565 52 -563 60 6 14 313 248 323 245 6 -2 63 -71 127 -152z m-327 96
c-11 -10 -65 -53 -119 -94 l-99 -75 -54 66 c-29 37 -53 70 -53 73 0 4 46 12
103 19 56 7 122 16 147 20 25 4 56 8 70 9 24 1 24 1 5 -18z m477 -330 c8 -7
180 -593 175 -597 -1 -2 -51 -23 -109 -48 l-107 -46 -353 91 c-194 50 -358 92
-364 94 -14 4 -18 34 -40 279 l-17 190 62 56 62 56 342 -35 c188 -18 345 -36
349 -40z m550 -495 c87 -71 158 -131 158 -135 -1 -5 -401 -313 -552 -424 l-38
-29 0 194 0 193 71 29 c66 27 70 31 64 55 -4 14 -47 166 -96 338 -49 172 -89
317 -89 324 0 6 73 -85 162 -202 160 -212 163 -215 320 -343z m468 -388 c135
-110 246 -204 248 -208 2 -5 -836 -304 -904 -322 -10 -3 -79 76 -191 218 l-31
40 170 129 c93 72 233 178 310 238 77 59 143 107 147 107 3 -1 116 -91 251
-202z" />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'LogoBlack',
}
</script>

<style scoped>
.my-svg-component {
    background-color: transparent;
    height: 75px;
    width: 110px;
    cursor: pointer;
    margin-top: -12px;
}
</style>